// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__3h4t5","title":"FrontImage_title__1ygTF"};